import { FormImage } from './FormImage'
import { parseLabel } from '../../parseLabel'

export const FormImagePrint = (props) => {
  const parsedTitle = parseLabel(props.title)
  return <FormImage {...props} title={parsedTitle} />
}
